import { render } from "./referee.vue?vue&type=template&id=5c0d961e&ts=true"
import script from "./referee.vue?vue&type=script&lang=ts"
export * from "./referee.vue?vue&type=script&lang=ts"

import "./referee.vue?vue&type=style&index=0&id=5c0d961e&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__